import {
  View,
  StyleSheet,
  Text,
  Image,
  ScrollView,
  TouchableOpacity,
} from "react-native";
import React, { useEffect, useState } from "react";
import StaticImages from "../../../../../assets/StaticImages";
import GlobalStyles from "../../../../../globalStyles/globalStyles";
import FeedIcons from "../../../../../assets/Icons/FeedIcons";
import { RootState, dispatch, useSelector } from "../../../../../redux/store";
import { fetchAllExperience } from "../../../../../redux/experience/experienceSlice";
import { getAllexperience } from "../../../../../services/Experience/experienceService";
import AsyncStorage from "@react-native-async-storage/async-storage";

export default function ExperienceFilter({
  filters,
  setFilters,
}: {
  filters: any;
  setFilters: any;
}) {
  const [experiences, setExperiences] = useState();
  useEffect(() => {
    const fetchExperience = async () => {
      const response = await getAllexperience();
      console.log("response", response);

      setExperiences(response?.data?.experiences || []);

      // // Check if there are selected experiences in the filters
      const selectedExperienceIds =
        filters.advanceFilters.experienceInterestedIn || [];

      // // Update the experiences state to mark selected experiences as active
      const updatedExperienceData = response?.data?.experiences?.map(
        (experience: any) => ({
          ...experience,
          active: selectedExperienceIds.includes(experience._id),
        })
      );
      setExperiences(updatedExperienceData);
    };

    fetchExperience();
  }, [filters.advanceFilters.experienceInterestedIn]);
  console.log("experiences", experiences);

  const handleExperienceClick = (index: any, experience: any) => {
    const updatedexperienceData = [...experiences];
    updatedexperienceData[index].active = !updatedexperienceData[index].active;
    setExperiences(updatedexperienceData);
    setFilters((prevFilters: any) => {
      const updatedFilters = {
        ...prevFilters,
        advanceFilters: {
          ...prevFilters.advanceFilters,
          // add ids in the experienceInterest array
          experienceInterestedIn: updatedexperienceData
            .filter((experience) => experience.active)
            .map((experience) => ({ id: experience._id })),
        },
      };

      // Save the updated state to AsyncStorage
      AsyncStorage.setItem("filters", JSON.stringify(updatedFilters));

      return updatedFilters;
    });
  };

  return (
    <ScrollView scrollEnabled={true} showsVerticalScrollIndicator={false}>
      <View style={styles.ExperienceCards}>
        {/* {experienceData.map((experience, index) => {
          return (
            <TouchableOpacity
              onPress={() => handleExperienceClick(index, experience)}
              key={index}
              style={styles.ExperienceCard}
              // press animation
              activeOpacity={0.8}
            >
              <View style={styles.ExperienceCardImgWrap}>
                {experience.active && (
                  <View style={styles.ImgLayer}>
                    <FeedIcons.TickCircle />
                  </View>
                )}

                <Image
                  source={experience.image}
                  style={styles.ExperienceCardImg}
                />
              </View>
              <Text style={[GlobalStyles.bodyTextBold, { marginTop: 6 }]}>
                {experience.label}
              </Text>
            </TouchableOpacity>
          );
        })} */}
        {experiences?.map((experience: any, index: any) => {
          return (
            <TouchableOpacity
              onPress={() => handleExperienceClick(index, experience)}
              key={index}
              style={styles.ExperienceCard}
              activeOpacity={0.8}
            >
              <View style={styles.ExperienceCardImgWrap}>
                {experience.active && (
                  <View style={styles.ImgLayer}>
                    <FeedIcons.TickCircle />
                  </View>
                )}
                <Image
                  source={{
                    uri:
                      experience.media?.images[0]?.url ||
                      "https://i.pinimg.com/564x/be/63/11/be63117bef0b4dadad9fee30acdd90da.jpg",
                  }}
                  style={styles.ExperienceCardImg}
                />
              </View>
              <Text style={[GlobalStyles.bodyTextBold, { marginTop: 6 }]}>
                {experience.title}
              </Text>
            </TouchableOpacity>
          );
        })}
      </View>
    </ScrollView>
  );
}
const styles = StyleSheet.create({
  ExperienceCardImgWrap: {
    position: "relative",
    borderRadius: 8,
    overflow: "hidden",
  },
  ImgLayer: {
    position: "absolute",
    zIndex: 1,
    width: "100%",
    height: "100%",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "rgba(0,0,0,0.4)",
  },
  ExperienceCards: {
    flexDirection: "row",
    flexWrap: "wrap",
    width: "100%",
    gap: 8,
    justifyContent: "space-between",
  },
  ExperienceCard: {
    width: "48%",
    marginBottom: 10,
  },
  ExperienceCardImg: {
    width: "100%",
    // height: '100%',
    height: 150,
    objectFit: "cover",
  },
});
